const NESTJS_URL = process.env.REACT_APP_NESTJS_URL || 'http://localhost:4000';

const ERROR_TRANSLATIONS: Record<string, string> = {
  'Wrong email or password': 'E-mail ou senha incorretos.',
  'Too many attempts': 'Muitas tentativas. Aguarde alguns minutos e tente novamente.',
  'Account blocked': 'Conta bloqueada. Entre em contato com o suporte.',
  'Login failed': 'Não foi possível fazer login. Tente novamente.',
  'Email already registered': 'Este e-mail já está cadastrado.',
  'Password does not meet requirements': 'A senha não atende aos requisitos mínimos.',
  'Invalid email': 'E-mail inválido.',
  'Registration failed': 'Não foi possível criar a conta. Tente novamente.',
};

export function translateError(err: unknown, defaultMessage: string): string {
  try {
    const raw = (err as any)?.message ?? '';
    const parsed = JSON.parse(raw);
    const msg: string = parsed.message ?? '';
    return ERROR_TRANSLATIONS[msg] ?? defaultMessage;
  } catch {
    return defaultMessage;
  }
}

export class CaseLimitError extends Error {
  periodEnd: number;
  constructor(periodEnd: number) {
    super('Limite de casos atingido');
    this.periodEnd = periodEnd;
  }
}

let _cachedToken: string | null | undefined = undefined; // undefined = not yet read

function getAuthHeaders(): HeadersInit {
  if (_cachedToken === undefined) {
    _cachedToken = localStorage.getItem('auth0_access_token');
  }
  return {
    'Content-Type': 'application/json',
    ...(_cachedToken ? { Authorization: `Bearer ${_cachedToken}` } : {}),
  };
}

// Call when token changes (login/logout)
export function invalidateAuthCache() {
  _cachedToken = undefined;
}

export async function apiPost<T>(path: string, body?: object): Promise<T> {
  const res = await fetch(`${NESTJS_URL}${path}`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const text = await res.text();
    if (res.status === 403) {
      try {
        const data = JSON.parse(text);
        if (data.periodEnd !== undefined) throw new CaseLimitError(Number(data.periodEnd));
      } catch (e) {
        if (e instanceof CaseLimitError) throw e;
      }
    }
    throw new Error(text.slice(0, 400));
  }
  return res.json() as Promise<T>;
}

export async function upgradeSubscription(priceId: string, planKey: string): Promise<void> {
  await apiPost('/checkout/upgrade', { priceId, planKey });
}

export async function apiGet<T>(path: string): Promise<T> {
  const res = await fetch(`${NESTJS_URL}${path}`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text.slice(0, 400));
  }
  return res.json() as Promise<T>;
}
